import Vue from 'vue'
import App from './App.vue'
import './plugins/element.js'

import router from './router.js'
import '@/h5style/h5style.scss';
import '@/bootstrap/bootstrap.min.css';
import fetchInstance from '@/api/fetchInstance.js';

import VueVideoPlayer from 'vue-video-player'

import 'video.js/dist/video-js.css'

Vue.use(VueVideoPlayer)

import store from './store'

import VueDND from 'awe-dnd'
Vue.use(VueDND)

// 引入全局配置
import $conf from './common/config/config.js';


Vue.prototype.$conf = $conf
Vue.config.productionTip = false

Vue.prototype.api = {
	get(url, options) {
		return fetchInstance(url, {
			...options,
			method: 'GET',
		});
	},
	post(url, options) {
		return fetchInstance(url, {
			...options,
			method: 'POST',
		});
	},
};

Vue.directive('auth', {
	inserted(el, binding, vnode, oldVnode) {
		let user = window.sessionStorage.getItem('user')
		user = user ? JSON.parse(user) : {}
		if (user.type != 1) {
			let rules = user.ruleNames ? user.ruleNames : []
			let v = rules.find(item => item === binding.value)
			if (!v) {
				el.parentNode.removeChild(el)
			}
		}
	}
})


new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app')